import styled from 'styled-components';

import { spaceMixin } from '@zillow/constellation';

export const StyledSearchBoxContainer = styled.div`
    width: 100%;
    border: 1px solid;
    border-color: ${props => props.theme.ns().colors.gray300};
    border-radius: 3px;

    &:hover {
        border-color: ${props => props.theme.ns().colors.blue400};
    }

    /* override constellation */
    & div[class^="StyledAdornedInput"] {
        height: 42px;
        box-shadow: none;

        input {
            width: 100%;
        }

        input,
        label {
            padding: ${spaceMixin('xs')} ${spaceMixin('sm')};
            height: auto;
            border: none;

            &:active,
            &:hover,
            &:visited,
            &:focus,
            &:focus-within {
                border: none;
            }

            &:focus {
                outline: currentColor
            }
        }

        svg {
            width: 22px;
            height: 22px;
        }
    }
`;
